<template>
  <div class="error-popup">
    <Modal
      size="auto"
      modal-style="loader"
      :show="show"
      @close="close"
      non-closable
    >
      <div class="error-popup__inner">
        <i class="error-popup__icon icon icon-alert"></i>
        <div class="error-popup__title">
          {{ titleText }}
        </div>
        <div class="error-popup__msg">
          {{ $t(`authentication-app.error-popup.${messageType}`) }}
        </div>
        <div class="error-popup__submit-row is-centered">
          <div class="error-popup__center-item">
            <button
              class="btn-back-link btn-back-link--mob-short"
              style="color: #000000"
              @click="close"
            >
              {{ $t(`authentication-app.error-popup.${buttonText}`) }}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
// TODO: Use UI kit component, once possible
import Modal from '../Modal';

export default {
  name: 'ErrorPopup',

  components: {
    Modal,
  },

  props: {
    show: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
    },
    isTimeout: {
      type: Boolean,
      required: false,
    },
    isTooMany: {
      type: Boolean,
      default: false,
    },
    isInvalidCredentialId: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    titleText() {
      if(this.title) {
        return this.title;
      }

      const base = 'authentication-app.error-popup.';

      if (this.isInvalidCredentialId) {
        return this.$t(base +  'invalid-credential-id-title');
      }

      const suffix = this.isTooMany ? 'too-many-title' : 'title';

      return this.$t(base + suffix);
    },
    messageType() {
      if (this.isInvalidCredentialId) {
        return 'invalid-credential-id-message';
      }

      return this.isTimeout ? 'timeout-message' : 'message';
    },
    buttonText() {
      if (this.isInvalidCredentialId) {
        return 'invalid-credential-id-button'
      }

      return 'button';
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.error-popup {
  &__submit-row {
    margin-top: rem(36);
    position: relative;
  }

  &__submit-row.is-centered {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__left-item {
    position: absolute;
    left: 0;
  }

  &__right-item {
    position: absolute;
    right: 0;
  }

  &__icon {
    font-size: rem(40);
    line-height: rem(24);
    margin: auto;
    padding-bottom: rem(32);
  }

  &__inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: rem(34) rem(32) rem(32) rem(32);
  }

  &__title {
    font-family: $font-bold;
    font-size: rem(18);
    line-height: rem(24);
    text-align: center;
  }

  &__msg {
    width: rem(480);
    margin-top: rem(4);
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    font-size: rem(14);
    line-height: rem(18);
  }

  &__submit {
    position: relative;
    margin-top: rem(32);
    display: flex;
    justify-content: center;
  }

  &__center-item {
    &:nth-child(1) {
      margin-right: 40px;
    }
  }

  @media screen and (max-width: $screen-xs-max) {
    &__msg {
      width: auto;
    }

    &__submit-row {
      flex-direction: column;
    }

    &__center-item {
      &:nth-child(1) {
        margin: 0 0 10px;
      }
    }
  }
}

@media screen and (max-width: $screen-xs-max) {
  .btn-back-link--mob-short {
    font-size: 1rem;
  }
}

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
